import * as baseAdapter from './baseAdapter';

export const searchReceipt = async (req: any) => {
  const ret = await baseAdapter.post<any>('/v1/receipt/inquiry', req);
  return ret;
};

export const receiptEntry = async (req: any) => {
  const ret = await baseAdapter.post<any>(
    '/v1/receipt/service/etaxsigndocument',
    req
  );
  return ret;
};

export const receiptVerify = async (req: any) => {
  const ret = await baseAdapter.post<any>(
    '/v1/receipt/getdocument/getdocumentstatus',
    req
  );
  return ret;
};

export const getReceiptLines = async (req: {
  ID: string;
  TYPECODE: string;
}) => {
  const ret = await baseAdapter.post<any>('/v1/receipt/lines', req);
  return ret;
};
